module.exports = __webpack_public_path__ + "static/img/5.75ea59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/5.png
// module id = PPHO
// module chunks = 0